    <div class="w-100 d-flex flex-column">
      <h2 class="title text-md-start text-center mb-0">Notes</h2>
      <div
      class="text d-flex flex-column mt-4 me-xl-32px me-lg-3 me-0 p-0 mb-0"
      [innerHTML]= "extraInformation | safeHtml"
    ></div>
    </div>
